import React from "react";
import { FaCar, FaUserTie, FaHandshake, FaHeadset, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Career = () => {
  return (
    <>
      {/* Breadcrumb */}
     
     
    <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">Career</h1>
          </div>
        </div>
      </div>


    

      {/* Career Section */}
      <section className="career-section">
        <div className="career-container">

          {/* Header */}
          <div className="career-header">
            <h2>
              Career at <span>Royal Route Cab</span>
            </h2>
            <p>
              Join Royal Route Cab as a Partner, Driver, Agent, or Back Office
              professional and build a successful career with a growing cab service brand.
            </p>
          </div>

          {/* Cards */}
          <div className="career-grid">

            {/* Partner */}
            <div className="career-card">
              <div className="career-icon">
                <FaHandshake />
              </div>
              <h4>Business Partner</h4>
              <p>
                Collaborate with Royal Route Cab and expand your transportation
                business with our strong network and support system.
              </p>
              <ul>
                <li>Fleet Expansion Support</li>
                <li>Long-Term Business Growth</li>
                <li>High Earning Opportunities</li>
              </ul>
            </div>

            {/* Driver */}
            <div className="career-card">
              <div className="career-icon">
                <FaCar />
              </div>
              <h4>Driver Partner</h4>
              <p>
                Become a driver partner and earn consistently with flexible
                schedules and reliable ride demand.
              </p>
              <ul>
                <li>Valid Driving License Required</li>
                <li>Own or Attached Commercial Vehicle</li>
                <li>Daily / Weekly Earnings</li>
              </ul>
            </div>

            {/* Agent */}
            <div className="career-card">
              <div className="career-icon">
                <FaUserTie />
              </div>
              <h4>Booking Agent</h4>
              <p>
                Manage bookings and assist customers with their travel needs as
                a Royal Route Cab agent.
              </p>
              <ul>
                <li>Commission-Based Earnings</li>
                <li>Handle Customer Bookings</li>
                <li>Work from Office or Remote</li>
              </ul>
            </div>

            {/* Back Office */}
            <div className="career-card">
              <div className="career-icon">
                <FaHeadset />
              </div>
              <h4>Back Office Executive</h4>
              <p>
                Support operations by handling bookings, billing, and customer
                service tasks efficiently.
              </p>
              <ul>
                <li>Office-Based Role</li>
                <li>Flexible Shifts (Day/Night)</li>
                <li>Growth & Learning Opportunities</li>
              </ul>
            </div>

          </div>

          {/* Contact Section */}
          <div className="career-contact">
            <h3>Contact for Career Opportunities</h3>
            <p>
              <FaPhoneAlt />{" "}
              <a href="tel:+919529877342">+91 9529877342</a>
            </p>
            <p>
              <FaEnvelope />{" "}
              <a href="mailto:booking@royalroutecabs.com">
                booking@royalroutecabs.com
              </a>
            </p>
          </div>

        </div>
      </section>
    </>
  );
};

export default Career;